import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericDecimalInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';


const TotalGrossPremiumInput: InputWithoutSource = ({ input }) => (
    <GenericDecimalInput label={input.name} input={input} />
);

TotalGrossPremiumInput.meta = {
    inputType: InputModel.name
};

export default observer(TotalGrossPremiumInput);
